










































































































































import { Mixin } from "@/core/mixins/mixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Image, Row, Col, Icon } from "vant";
import { monitorEvent } from "@/utils/youMengMonitor";
import { zhugeTrack } from "@/utils";
// import { keyword715, hasKeyword, has715Label } from "@/utils/label715";

@Component({
  components: {
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
  },
})
export default class showProList extends Mixins(Mixin) {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public projectList!: Array<good.RecommendProductDto>;
  @Prop({
    type: String,
    default: "",
  })
  public keyword!: "";
  @Prop({
    type: Boolean,
    default: false,
  })
  public component!: boolean;
  @Watch("projectList", { deep: true })
  changeProjectList(val: Array<good.RecommendProductDto>): void {
    this.projectList = val;
  }
  @Prop({
    type: Number,
    default: () => {
      -1;
    },
  })
  public scrollTop!: number;
  @Prop({
    type: String,
    default: () => {
      return "";
    },
  })
  categoryId!: string;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  zhugeParams!: any; // 埋点参数
  @Prop({ default: "", type: String }) public type?: string; // 组件调用的页面
  // keyword715 = keyword715;

  lineheight(str?: string): string {
    let string = str || "";
    if (this.keyword) {
      let reg = new RegExp(this.keyword, "g");
      string = (str as string).replace(reg, "<em>" + this.keyword + "</em>");
    }
    return string;
  }
  goProDetail(index: number, item: good.RecommendProductDto): void {
    if (this.type == "search" || this.type == "searchRecommend") {
      if (this.type == "search") {
        zhugeTrack("个人-点击搜索结果", {
          ...this.zhugeParams,
          位置序号: index,
        });
      }
      this.$router.push(
        `/projectdetail/${item.productId}/${item.tourId}?pageSource=search`
      );
    } else {
      if (this.component) {
        this.$emit("goProDetail", item);
      } else {
        let theaterId = this.TheaterModule.theaterId;
        this.jsBridge(
          "goProDetail",
          {
            productId: item.productId,
            theaterId: theaterId,
            taskId: "",
          },
          () => {
            this.goToProjectDetail(item.productId, item.tourId, item.tour);
          }
        );
      }
    }
  }
  // hasKeyword(name: string | undefined, keyword: string) {
  //     return hasKeyword(name, keyword);
  // }
  // has715Label(name: string | undefined) {
  //     return has715Label(name);
  // }
}
